import { usePhotos } from "./usePhotos.web";

export const useSignatureProofs = (projectId: string, objectId: string) =>
  usePhotos("signatureProofs", projectId, objectId);
